import api from "@/services/api";

export default {
  namespaced: true, // Name of namespace exists here '@/store/namespaces'
  state: {
    pendingActions: null,
  },
  getters: {
    getPendingActions: (state) => {
      return state.pendingActions;
    },
  },
  mutations: {
    setPendingActions: (state, pendingActions) => {
      state.pendingActions = pendingActions;
    },
  },
  actions: {
    async fetchPendingActions(
      { commit, getters },
      { qryParams, force = false }
    ) {
      try {
        if (getters.getPendingActions && !force) {
          // If we already have pending actions in state and not forcing, we can skip the API call
          return;
        }

        const response = await api.get("/pending-actions", {
          params: qryParams,
        });
        commit(
          "setPendingActions",
          response.data.map((pa) => pa.item)
        );
      } catch (error) {
        console.error("Error fetching pending actions:", error);
      }
    },
  },
};
